import * as React from 'react';
import {useState, useEffect} from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TextField, Button, FormControl, makeStyles } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DoNotTouchOutlinedIcon from '@mui/icons-material/DoNotTouchOutlined';
import {GridRowModes, DataGrid, GridToolbarContainer, GridActionsCellItem, GridRowEditStopReasons, GridEditInputCell} from '@mui/x-data-grid';
import { createFakeServer } from '@mui/x-data-grid-generator';
import { useDispatch, useSelector } from "react-redux";

import RecipeService from '../../services/recipe.service';
import AuditTrailViewService from '../../services/audittrailview.service.js';
import ConfigurationViewService from '../../services/configurationview.service.js';
import ParameterListAdd from './ParameterListAdd.js';

import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { styled } from '@mui/material/styles';

import {Resizable, ResizableBox} from "re-resizable";

import Alert from '@mui/material/Alert';
import { Hidden } from '@mui/material';


// Add form open for tag addition in selected widget/dashboard.
function EditToolbar(props) {
  const { addTagIconStatus, setAddRecordForm, widgetDescription, user} = props;

  const handleClick = () => {
    setAddRecordForm(true);
  };

  const isTagAddAccess = user && user.UserAccess && user.UserAccess[15] && user.UserAccess[15].Enable === "Enabled" && user.UserAccess[15].Options 
  ? user.UserAccess[15].Options.includes(user.role)
  : false; // Default to false if user or the necessary properties are null or undefined

  return (
    <GridToolbarContainer
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#A9BBD3',
    }}
    >
      {((isTagAddAccess || user.role === "engineer"  || user.role === "superadmin")) &&(
        <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
        
        </Button>
      )}

      <span 
        style={{ 
          marginLeft: 'auto',
          marginRight: 'auto',
          fontWeight: 'bold', // Make text bold
          fontSize: 16, // Set font size to 16
          color: 'black', // Set color to black

        }}>
          Recipe Parameter List 

        </span>

      
      
    </GridToolbarContainer>
  );
}

//Function to merge two array data
function mergeByTagName(arr1, arr2) {
  // Use Map for fast lookup
  const map = new Map();

  // Add first array
  arr1.forEach(item => {
    map.set(item.TagName, { ...item });
  });

  // Merge second array
  arr2.forEach(item => {
    if (map.has(item.TagName)) {
      const existing = map.get(item.TagName);
      map.set(item.TagName, { ...existing, ...item });
    } else {
      map.set(item.TagName, { ...item });
    }
  });

  return Array.from(map.values());
}

export default function Dasboard() {
  const { user } = useSelector((state) => state.auth);
  const projectName = user.selectedproject;
  const dashboardType = 'RecipeParameterList';
  //const widgetName = useSelector((state) => state.splitbutton1.widgetName);
  const widgetName = useSelector((state) => state.splitbutton12WidgetName.widgetName);
  const widgetDescription = useSelector((state) => state.splitButton12WidgetDescription.widgetDescription);
  //console.log(widgetName)
  //console.log(widgetDescription)

  const [fetchData, setFetchData] = useState(true);
  const[recipeParameterListData, setRecipeParameterListData] = useState([]);

  const[rowData, setRowData] = useState([]); // Selected row data

  const [addRecordForm, setAddRecordForm] = React.useState(false)
  const [editRecordForm, setEditRecordForm] = React.useState(false)
  const [editRowData, setEditRowData] = React.useState(false)

  const[deleteDialog, setDeleteDialog] = React.useState(false); // Delete Dialog bit
  const noButtonRef = React.useRef(null); 
  const [rowTagName, setRowTagName] = React.useState(); // Row Id refernace to delete the record
  const[deleteData, setDeleteData] = React.useState(false); //Delete row bit
  const [snackbar, setSnackbar] = React.useState(null); // if delete Success then set to success otherwise will set to fail
  const handleCloseSnackbar = () => setSnackbar(null);
  const [fetchingProgress, setFetchingProgress] = useState(0);
  const[addTagIconStatus, setAddTagIconStatus] = useState(true)

  const[remarkDialog, setRemarkDialog] = React.useState(false); // Remark Dialog bit
  const [eventDescription, setEventDescription] = useState("--");
  const [auditTrailRemark, setAuditTrailRemark] = useState("--");
  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState('');
  const[pwdinterlock, setPwdInterlock] = useState("Disabled");
  
    
  // Progress bar
  const ProgressBar = ({ progress }) => {
    return (
      <div className="progress">
        <div className="progress-bar" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    );
  };

  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
  useEffect(() =>{
    async function auditTrailConfigData()  {
    try {

      let dashboardName = 'AuditTrailConfig';
      let columnName = 'EventName';
      let columnValue = 'Remove Parameter From Recipe';
      let response = await AuditTrailViewService.getColumnData(dashboardName, columnName, columnValue);

      //console.log(response.data[0].EnableRemark);
      if(response.data.length > 0){
        setRowData({...rowData, EventStatus: response.data[0].EnableEvent, PWDInterlock: response.data[0].EnablePwdInterlock, RemarkStatus: response.data[0].EnableRemark});
        setPwdInterlock(response.data[0].EnablePwdInterlock);
        setEventDescription(response.data[0].DefaultEventDescription);
        // If remark field is disabled then set default remark vlaue to currrent Remark value
        if(response.data[0].EnableRemark === "Disabled"){
          setAuditTrailRemark(response.data[0].DefaultEventRemark);
        }
        
      }

    } catch (error) {
      console.log(error);

    }
  }

  auditTrailConfigData();

  }, []);

  //Get RecipeParameterList data for selected widget
  useEffect(() =>{
    async function getColumnData()  {
    try {

      let dashboardName = "RecipeParameterList";
      
      const response = await RecipeService.getAllRowsData(dashboardName);
      //console.log(response.data[16].FontWeight);
      if(response){
        //console.log(response.data);
        //console.log(response.data[0].TagName);
        setRecipeParameterListData(response.data);
        setFetchingProgress(100);
        setFetchData(false);

      }
      
      
    } catch (error) {
      console.log(error);
      setFetchData(false);

    }
  }
    getColumnData();

  
  }, [fetchData]);

    
  // Delete  Specific Row row data 
  useEffect(() =>{
    async function deleteRowData()  {
    try {

      let dashboardName = "RecipeParameterList"
      let auditTrailData =[{
        TimeStamp:new Date(),
        Activity: `Removed parameter '${rowData.TagName}' from recipe - '${widgetName}'`,
        ActivityType: "Remove Parameter From Recipe",
        UserName: user.email,
        Role: user.role,
        Remark: auditTrailRemark,
        EventStatus: rowData.EventStatus,
      }]

      const searchValue = rowData.TagName; // The value you're searching in RecipeParameterList collection to get record to retrive _id field from it.
   
      const foundObject = recipeParameterListData.find((item) => item.TagName === searchValue);

      //console.log(searchValue, foundObject)
      if (foundObject) {
        //console.log('Object found:', foundObject._id);
        let rowId = foundObject._id;
        //console.log(rowId, rowData._id)
        if (rowId === null){
          setSnackbar({ children: 'TagName value is null', severity: 'error' });
        }else{
          //let updatedRowData = {...rowData, _id: rowId, WidgetName: widgetName}
          let updatedRowData = {...rowData, _id: rowId, WidgetName: widgetName, email:user.email, role: user.role, PWDInterlock: pwdinterlock, PWD: password};
          //console.log(dashboardName, updatedRowData);
          const response = await RecipeService.deleteRow(dashboardName, updatedRowData, auditTrailData);  // update when id is present in data array
          if(response){
            setAuditTrailRemark("--"); // Clear remark field
            setSnackbar({ children: 'Tag Deleted successfully', severity: 'success' });
            setFetchData(true);
          
          }
        }

      } else {
        setSnackbar({ children: 'TagName is not present', severity: 'error' });
      }
    

    } catch (error) {
      setSnackbar({ children: "Tag deletion Failed", severity: 'error' });
      console.log(error);
      setAuditTrailRemark("--"); // Clear remark field

    }
  };
  if(deleteData){
    deleteRowData();
    setDeleteData(false);
  };


  }, [deleteData]);
    
  
  const handleClose = () => {
    setOpenRemarkBlnkMsg(false);
  };

  const handleRecordAdded = (data) => {
    
    setAddRecordForm(false);
    setFetchData(true);  // reload the data again from backend
    //console.log("Record Added", data);
    
  };

  const handleDeleteYes = () => {
    setDeleteData(true);
    setDeleteDialog(false);
    setRemarkDialog(false);
  };

  const handleDeleteNo = () => {
    
    setDeleteDialog(false);
    setRemarkDialog(false);
    setAuditTrailRemark("--"); // Clear remark field
  };

  const renderDeleteConfirmDialog = () => {
    if (!deleteDialog) {
      return null;
    }

    //const { newRow, oldRow } = promiseArguments;
    //const mutation = computeMutation(newRow, oldRow);
    return (
      <div>

      <Dialog
        maxWidth="xs"
        //TransitionProps={{ onEntered: handleEntered }}
        open={!!deleteDialog}
      >
        <DialogTitle>Are you sure to delete selected Row?</DialogTitle>
        <DialogContent dividers>
          {`Pressing 'Yes' will delete the selected row.`}
        </DialogContent>
        
        {pwdinterlock === 'Enabled' && (<DialogContent dividers>
          <DialogContentText>
            Enter the Password to delete the selected record from recipe.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="Password"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            onChange={(event) => {
              setPassword(event.target.value);
            }}
          />

          </DialogContent>
        )}

        <DialogActions>
          <Button ref={noButtonRef} onClick={handleDeleteNo}>
            No
          </Button>
          <Button onClick={handleDeleteYes}>Yes</Button>
        </DialogActions>
      </Dialog>

      </div>
    );
  };

  const handleDelete = () => ()=> {   
    if(((rowData.RemarkStatus === "Enabled") && (auditTrailRemark === "--")) || ((rowData.RemarkStatus === "Enabled") && (auditTrailRemark === ""))){
      setOpenRemarkBlnkMsg(true);
      //console.log("Enter or change the Remark value to proceed further")
    }else{
      //console.log("test2");
      setDeleteDialog(true);
      setRemarkDialog(false);
      
    }
    
  };

  const handleRemarkChange = (event) => {
    const {name, value} = event.target;
    if(rowData.RemarkStatus === "Enabled"){
      setAuditTrailRemark(value);

    }
  };

  const renderRemarkDialog = () => {
    if (!remarkDialog) {
      return null;
    }

    //console.log("test1");
    //const { newRow, oldRow } = promiseArguments;
    //const mutation = computeMutation(newRow, oldRow);
    return (
      <div>

      <Dialog
        maxWidth="xs"
        //TransitionProps={{ onEntered: handleEntered }}
        open={!!remarkDialog}
      >
        <DialogTitle>Enter Remark</DialogTitle>
        {/*Remark */}
        <DialogContent 
        dividers
        >
          <Typography gutterBottom sx={{ mt: 0, mb:3, width: 350 }}>
          Enter remark or reason for delete action
          </Typography>

          <TextField
            id="outlined-multiline-static"
            label="Remark"
            name="Remark"
            placeholder="Enter Remark"
            multiline
            rows={2}
            style={{ width: 350 }}
            onChange={handleRemarkChange}
            //defaultValue="Default Value"
          />

        </DialogContent>


        <DialogActions>
          <Button ref={noButtonRef} onClick={handleDeleteNo}>
            Cancel
          </Button>
          <Button onClick={handleDelete()}>Delete</Button>
        </DialogActions>
      </Dialog>

      </div>
    );
  };

  const handleDeleteClick = (params) => () => {
    setRowData({...params.row, RemarkStatus: rowData.RemarkStatus, EventStatus:rowData.EventStatus});
    if(rowData.RemarkStatus === "Enabled"){
      //console.log("test0");
      setRemarkDialog(true);
    }else{
      //console.log("test0");
      const withoutRemark = handleDelete();
      withoutRemark();
    }
  };

  const isRecipeViewSPChangeAccess = user && user.UserAccess && user.UserAccess[14] && user.UserAccess[14].Options 
  ? user.UserAccess[14].Options.includes(user.role)
  : false;


  const handleAddClick = (params) => () => {
    //console.log(params);
    setAddRecordForm(true);

  }

  const columns = [
    { field: 'SrNo', headerName: "Sr. No.", width: 80, headerAlign: "center", align: "center", headerClassName: 'theme--header', },
    { field: 'ParameterName', headerName: "Parameter Name", width: 300, headerAlign: "center", align: "center", headerClassName: 'theme--header',},
    { field: 'ParameterUnit', headerName: "Unit", width: 150, headerAlign: "center", align: "center", headerClassName: 'theme--header', },
    { field: 'TagName', headerName: "Assigned Tag", width: 300, headerAlign: "center", align: "center", headerClassName: 'theme--header',},
    { field: 'recipegroupnamelist', headerName: 'Assigned Recipe Groups', type: 'string', width: 250, align: 'center', headerAlign: 'center',
      renderCell: (params) => (
        <ul style={{ margin: 0, padding: 1, listStyleType: 'square' }}>
          {params.value && params.value.length > 0 && params.value.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      ),},
    (user.role !== "visitor") &&      
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'theme--header',
      width: 0,
      hideable: true,
      hide: false,
      cellClassName: 'actions',
      getActions: (params) => {
        const tagName = params.row.TagName;
        const actions = [];
        actions.push(
            <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(params)}
            color="inherit"
            />
        );

        return actions;

        
      },
      
    },

  ];

 
  return (
    <div >

      {renderDeleteConfirmDialog()}
      {renderRemarkDialog()}
      <Paper
       style={{ maxWidth: 'fit-content', flex: 1, padding: '6px' }}
        sx={{
          width: "100%",
          margin: "auto",
          position: "relative",
          overflow: "hidden",

          "& .MuiDataGrid-main": {
            overflowX: "hidden",
            overflowY: "auto",
          },

          "& .theme--header": {
            backgroundColor: "#1565C0",
            color: "#FFFFFF",
            fontSize: "15px",
            fontWeight: 700,
            border: "1px solid #CFCFCF",
            whiteSpace: "normal",
            wordBreak: "break-word",
            textAlign: "center",
          },

          "& .theme--row": {
            backgroundColor: "#FFFFFF",
            color: "#333333",
            fontSize: "14px",
            fontWeight: 500,
            overflowWrap: "break-word",
          },

          "& .theme--verborder": {
            border: "1px solid #E0E0E0",
          },

          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#1565C0",
            color: "#FFFFFF",
            borderBottom: "2px solid #0D47A1",
          },

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
            fontSize: "15px",
          },

          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid #E0E0E0",
            display: "flex",
            alignItems: "center",
          },

          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#F8F9FA",
          },

          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#E3F2FD",
          },

          "& .MuiDataGrid-footerContainer": {
            display: "none",
          },
        }}
        elevation={24}
      >
         {/* <Box display="flex" alignItems="center" justifyContent="center" border={0} p={0} sx={{'&.MuiDataGrid-main':{overflowX:'hidden ! important', overflowY:'hidden ! important'}}}> */}
         <Box >
        {fetchingProgress < 100 ? (
          <div style={{ height: 50, width: '100%', overflowX: 'hidden', overflowY: 'hidden' }}>
          <p>Data fetching in progress...</p>
          <ProgressBar progress={fetchingProgress} />
        </div>
        ):(
          <div style={{ height: '100%', width: '100%', overflowX: 'hidden', overflowY: 'hidden' }} >
            <DataGrid
            rows={recipeParameterListData}
            getRowId={(recipeParameterListData) => recipeParameterListData._id} // This line will set id of the datagrid row = _id of the mongodb database, otherwisw error can occured.
            columns={columns} 
            disableRowSelectionOnClick  // disable row selection
            getHeaderClassName={(params) =>{return 'theme--header';}}
            getRowClassName={(params) => {return 'theme--row';}}

            sx={{
              //width:'1678px',
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#A9BBD3"
                // on hover, background color of thr row
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: 1.2
                // wrap the column header text
              },
              "& .MuiDataGrid-cell": {
                whiteSpace: 'normal !important', /* Important to override other styles */
                lineHeight: 1.2,
                wordWrap: 'break-word',
                // wrap the  cell text
              },
            }}

            slots={{ toolbar: EditToolbar, }}
            slotProps={{ toolbar: { addTagIconStatus, setAddRecordForm, widgetDescription, user}, }}
          />
          </div>
          
        )}
          
        </Box>

        {(addRecordForm && user.role !== "visitor") && (
        <ParameterListAdd open= {addRecordForm} close = {handleRecordAdded} />
        )}


        {!!snackbar && (
          <Snackbar anchorOrigin={{ vertical:"top", horizontal:"center" }}  open onClose={handleCloseSnackbar} autoHideDuration={4000}>
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}

        {/* Open Remark Field is blank dialog box */}
        <Dialog open={openRemarkBlnkMsg} onClose={handleClose}>
          <DialogTitle>Enter Remark Field</DialogTitle>
          <Box sx={{width: 450 }}>
          <DialogContent dividers>
            <DialogContentText>
                Enter or change the Remark Field to proceed further.
                <br />
                (Note: '--' Value for remark field is not acceptable)
            </DialogContentText>
            
          </DialogContent>
          </Box>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>

      </Paper>
    </div>
  );
}